export class ServerTrunk {
    id: number;
    name: string;
    trunk_host: string;
    trunk_username: string;
    trunk_secret: string;
}
